import { useState } from "react";
import { Link } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { CATS, SUBS, subLink } from "../lib/categories";
import { t } from "../lib/i18n";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";

export default function MobileCategories() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button data-testid="mobile-all-categories" onClick={() => setOpen(true)} className="md:hidden shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#ff5500] text-white font-semibold"><LayoutGrid size={13} />{t("All categories")}</button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-[85vw] max-w-sm overflow-y-auto bg-[#0c0d13] border-white/10" data-testid="mobile-categories-sheet">
          <SheetHeader><SheetTitle>{t("All categories")}</SheetTitle></SheetHeader>
          <div className="mt-4 space-y-4">
            {CATS.map((c) => (
              <div key={c.slug}>
                <Link to={subLink(c.slug)} onClick={() => setOpen(false)} data-testid={`mobile-cat-${c.slug}`} className="font-semibold text-[#ff5500]">{t(c.name)}</Link>
                <div className="flex flex-wrap gap-1.5 mt-2">{SUBS[c.slug].map((s) => (
                  <Link key={s} to={subLink(c.slug, s)} onClick={() => setOpen(false)} className="text-xs px-2.5 py-1 rounded-full border border-white/15 text-slate-300">{s}</Link>
                ))}</div>
              </div>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
